import { Box } from '@mui/material';
import { useState } from 'react';

import { png, svg } from './logos';

interface Props {
  variant?: keyof typeof png | keyof typeof svg;
  fileFormat?: 'png' | 'svg';
  width?: string;
  placeholderHeight?: string;
}

export function Logo({
  variant = 'logoWhite',
  fileFormat = 'svg',
  width = '100%',
  placeholderHeight = '100%',
}: Props) {
  const [isLoadingLogo, setIsLoadingLogo] = useState(true);

  const logo = fileFormat === 'png' || variant === 'logoWithSlogan' ? png[variant] : svg[variant];

  return (
    <div>
      <Box height={placeholderHeight} display={isLoadingLogo ? 'block' : 'none'} />

      <img
        src={logo}
        alt=""
        style={{ display: isLoadingLogo ? 'none' : 'block' }}
        onLoad={() => setIsLoadingLogo(false)}
        width={width}
      />
    </div>
  );
}
